import { forwardRef, useEffect, useState } from 'react';

import { WebEDIError } from 'services/webediErrors/types';
import { useWebEDIStore } from 'stores/webedi/webedi';
import { IssueResolverType } from 'support/types';
import { InfoPopover } from 'components/InfoPopover/InfoPopover';

import { WithErrorsContent } from './components/WithErrorsContent';
import { WithoutErrorsContent } from './components/WithoutErrorsContent';

type MessageFieldErrorModalProps = {
  style?: React.CSSProperties;
  error: WebEDIError | undefined;
  numberOfErrors: number;
  isValidating?: boolean;
  isPendingValidation?: boolean;
  viewMode: boolean;
  fieldDescription: string | undefined;
};

export const MessageFieldErrorModal = forwardRef<HTMLDivElement, MessageFieldErrorModalProps>(
  ({ style, error, numberOfErrors, isValidating, isPendingValidation, viewMode, fieldDescription }, ref) => {
    const [errorState, setErrorState] = useState<MessageFieldErrorModalProps['error']>(error);
    const issueResolver = useWebEDIStore((state) => state.issueResolver);
    const isPartnerIssueResolver = issueResolver === IssueResolverType.CURRENT_PARTNER;

    useEffect(() => {
      if (error) {
        setErrorState(error);
      }
    }, [error]);

    if (!errorState) {
      return null;
    }

    const isErrorFixed = errorState && !error;
    const hasErrors = numberOfErrors > 0;

    return (
      <InfoPopover ref={ref} style={style}>
        {hasErrors ? (
          <WithErrorsContent
            isErrorFixed={isErrorFixed}
            error={errorState}
            numberOfErrors={numberOfErrors}
            isValidating={isValidating}
            isPendingValidation={isPendingValidation}
            viewMode={viewMode}
            isPartnerIssueResolver={isPartnerIssueResolver}
            fieldDescription={fieldDescription}
          />
        ) : (
          <WithoutErrorsContent />
        )}
      </InfoPopover>
    );
  },
);

MessageFieldErrorModal.displayName = 'DocumentFieldErrorModal';
